import {FileInputTextMap} from './types';

export const defaultTextMap: FileInputTextMap = {
    actionChoose: 'Choose File(s)',
    actionAdd: 'Add File(s)',
    actionClear: 'Clear File(s)',
    actionDrop: 'Drop to Upload',
    actionSupplement: 'or drag here to upload',

    guardTitle: 'Guards',
    guardSupplement: 'Minimum file requirements. Files that do not meet these requirements will not be evaluated further (or accepted).',
    guardAcceptedFiles: 'Accept',
    guardMinSize: 'Min Size',
    guardMaxSize: 'Max Size',
    guardMaxFiles: 'Max Files',

    validationTitle: 'Validations',
    validationSupplement: 'Files that pass the guards above, will be evaluated to see if they meet the custom requirements below. If they do, the upload will begin. The file status can be viewed by hovering over the file status icon.',

    errorMessages: {
        fileTooLarge: 'File is too big',
        fileTooSmall: 'File is too small',
        tooManyFiles: 'Too many files',
        fileInvalidType: 'Wrong file type'
    },

    listItemRemove: 'Remove Item',
    listItemSupplement: 'Hover over file status to see individual validations.',

    rejectedFileAlertTitle: 'file(s) failed to follow constraints:',
    fileStatusIconLabels: {
        unvalidated: 'Unvalidated:',
        success: 'Success:',
        warning: 'Warning:',
        error: 'Error:',
        validating: 'Validating'
    }
};
